module.exports = __webpack_public_path__ + "img/banner_450x2.5e17efd2.jpg";